import { render } from "./Exams.vue?vue&type=template&id=594e3ace"
import script from "./Exams.vue?vue&type=script&lang=js"
export * from "./Exams.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__